/**
 * Intelligems custom events for product pages.
 * @see https://docs.intelligems.io/analytics/custom-events/custom-javascript-events
 */

const CAROUSEL_CLICK_EVENT = 'javascripteventCKPAZ';
const DRAG_THRESHOLD_PX = 40;

const pushIgEvent = (eventName) => {
  window.igEvents = window.igEvents || [];
  window.igEvents.push({ event: eventName });
  console.log('[Intelligems]', eventName);
};

const isCarouselControlClick = (target) => {
  if (!(target instanceof Element)) return false;

  return Boolean(
    target.closest('.splide__arrow') ||
      target.closest('.splide__pagination__page') ||
      target.closest('.product-media-gallery__thumbnail')
  );
};

class IntelligemsProductMetrics {
  constructor() {
    this.#bindGalleries();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.#bindGalleries(), { once: true });
    }
  }

  #bindGalleries() {
    const galleries = document.querySelectorAll('product-media-gallery');

    for (const gallery of galleries) {
      if (gallery.dataset.igCarouselBound === 'true') continue;

      gallery.dataset.igCarouselBound = 'true';
      this.#bindGallery(gallery);
    }
  }

  #bindGallery(gallery) {
    gallery.addEventListener('click', (event) => {
      if (!isCarouselControlClick(event.target)) return;
      pushIgEvent(CAROUSEL_CLICK_EVENT);
    });

    this.#bindDrag(gallery);

    const observer = new MutationObserver(() => this.#bindDrag(gallery));
    observer.observe(gallery, { childList: true });
  }

  #bindDrag(gallery) {
    const track = gallery.querySelector('[data-ref="main-slider"] .splide__track');
    if (!track || track.dataset.igDragBound === 'true') return;

    track.dataset.igDragBound = 'true';

    let startX = null;

    track.addEventListener('pointerdown', (event) => {
      startX = event.clientX;
    });

    track.addEventListener('pointerup', (event) => {
      if (startX === null) return;

      if (Math.abs(event.clientX - startX) >= DRAG_THRESHOLD_PX) {
        pushIgEvent(CAROUSEL_CLICK_EVENT);
      }

      startX = null;
    });

    track.addEventListener('pointercancel', () => {
      startX = null;
    });
  }
}

new IntelligemsProductMetrics();
